'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _iview = require('iview');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    size: {
      type: String,
      default: 'small'
    },
    map: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showModal: false
    };
  },

  computed: {
    width: function width() {
      return this.map[this.size];
    }
  },
  watch: {
    value: function value(newVal) {
      var _this = this;

      this.$nextTick(function () {
        _this.showModal = newVal;
      });
    }
  },
  created: function created() {
    var defaultMap = {
      large: '768',
      small: '416'
    };
    this.map = (0, _assign2.default)(this.map, defaultMap);
  },
  render: function render(c) {
    var _this2 = this;

    return this.value ? c('div', {}, [c(_iview.Modal, {
      props: {
        value: this.showModal,
        width: this.width
      },
      attrs: (0, _extends3.default)({}, this.$attrs),
      ref: 'customModal',
      class: 'iv-custom-modal',
      scopedSlots: (0, _extends3.default)({
        default: function _default(props) {
          return c('div', {
            class: 'iv-content-box'
          }, _this2.$slots.default);
        }
      }, this.$slots.header ? {
        header: function header(props) {
          return c('div', _this2.$slots.header);
        }
      } : {}, this.$slots.footer ? {
        footer: function footer(props) {
          return c('div', _this2.$slots.footer);
        }
      } : {}),
      on: {
        input: function input(event) {
          _this2.showModal = false;
          _this2.$emit('input', event);
        },
        'on-ok': function onOk() {
          _this2.removeHidden();
          _this2.$emit('on-ok');
        },
        'on-hidden': function onHidden() {
          _this2.showModal = false;
          _this2.removeHidden();
          _this2.$emit('on-hidden');
        },
        'on-cancel': function onCancel() {
          _this2.removeHidden();
          _this2.$emit('on-cancel');
        },
        'on-visible-change': function onVisibleChange(res) {
          return _this2.$emit('on-visible-change', res);
        }
      }
    }, [this.$slots.header ? c('div', {
      slot: 'header'
    }, this.$slots.header) : ''])]) : c('');
  },

  methods: {
    removeHidden: function removeHidden() {
      var ishidden = document.body.style.overflow === 'hidden';
      ishidden && (document.body.style.overflow = 'initial');
    },
    close: function close() {
      this.$refs.customModal.visible = false;
      this.$emit('input', false);
      this.showModal = false;
    }
  }
};